import { SafePromise } from '@benzinga/safe-await';
import { ExtendedSubscribable } from '@benzinga/subscribable';

import { Session } from '@benzinga/session';
import { FormattedVideoItem, VideosResponse, YouTubeClearCacheParams } from './entities';
import { VideosRequest, VideosRequestEvent } from './request';

interface VideosFunctions {
  getFeaturedVideos: VideosManager['getFeaturedVideos'];
}

export type VideosManagerEvent = VideosRequestEvent;

export class VideosManager extends ExtendedSubscribable<VideosManagerEvent, VideosFunctions> {
  private request: VideosRequest;

  constructor(session: Session) {
    super();
    this.request = new VideosRequest(session);
  }

  public static getName = () => 'benzinga-videos';

  public getFeaturedVideos = async (): SafePromise<VideosResponse | undefined> => {
    return await this.request.getFeaturedVideos();
  };

  public getYouTubePlaylist = async (
    id: string,
    options?: {
      maxResults?: number;
      type?: 'any' | 'video' | 'shorts';
    },
  ): SafePromise<FormattedVideoItem[]> => {
    return await this.request.getYouTubePlaylist(id, options);
  };

  public resetYouTubeCache = async ({ action, keys, pattern }: YouTubeClearCacheParams) => {
    return await this.request.resetYouTubeCache({ action, keys, pattern });
  };

  protected onSubscribe(): VideosFunctions {
    return {
      getFeaturedVideos: this.getFeaturedVideos,
    };
  }
}
